/**
 * Project Andromeda
 * Denis Callinan
 * May 14th, 2020
 * InfoBox.js - React component for front page InfoBox
 */

import React from 'react';

// CSS
import './InfoBox.css'

export default function InfoBox(){
    return(
        <div className = "infoBox">
            <h2 id="title">Hello, I'm</h2>
            <h1 id="name">DENIS CALLINAN</h1>
            <div id = "break"/>
            <h2 id="body">Rodman Scholar at the <br/> University of Virginia</h2>
        </div>
    );
}